export default __webpack_public_path__ + "static/media/aiButton.a4d30f88.svg";